import React from "react";
import Grid from "@material-ui/core/Grid";
import MyPagination from "Components/MyPagination";
import Layout from "Layout";
import {
  fromMonthly,
  toMonthly,
  fromDaily,
  toDaily,
  fromHourly,
  toHourly,
  fromDetail,
  toDetail,
} from "fuction/date";
import { withRouter } from "react-router";
import queryString from "query-string";
import Tweet from "Components/Tweet";
import PosiTabs from "Components/PosiTabs";
import OrderSelect from "Components/OrderSelect";
import DatePickers from "Components/DatePickers";
import DateSinglePicker from "Components/DateSinglePicker";
import DateTimePicker from "Components/DateTimePicker";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import useAuth from "Hooks/useAuth";
import useApi from "Hooks/useApi";
import useFilter from "Hooks/useFilter";
import { makeStyles } from "@material-ui/core/styles";
import { animateScroll as scroll } from 'react-scroll';
import googleAnalytics from "fuction/googleAnalytics";
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import Switch from '@material-ui/core/Switch';
import Toolbar from '@material-ui/core/Toolbar';
import { useQueryString, modQueryPageNum, getQueryPageNum } from "Hooks/useQueryString";

const useStyles = makeStyles((theme) => ({
  divider: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(3),
    minWidth: 120,
  },
  sticky: {
    position: "-webkit-sticky", /* safari対応 */
    position: "sticky",
    top: 64,
    zIndex: 1,
    backgroundColor: "white",
    paddingLeft: 90,
    paddingRight: 90,
    width: "100%",
  },
}));

function Page(props) {
  const auth = useAuth();
  const filter = useFilter();
  const classes = useStyles();
  const queryParams = useQueryString();
  const activeGroup = auth.state.activeGroup;

  // 時間間隔を取得
  // 5m minutes / 1h hourly / 1day daily / 1month monthly
  const interval = queryString.parse(props.location.search).interval;
  const date = queryString.parse(props.location.search).date;
  const [page, setPage] = React.useState(getQueryPageNum(queryParams));
  const [totalCount, setTotalCount] = React.useState(0);
  const [retweetCount, setRetweetCount] = React.useState(0);
  const [order, setOrder] = React.useState("retweet");
  const [tweets, setTweets] = React.useState([]);
  const [isHideImage, setIsHideImage] = React.useState(false);
  const { request, convertQueryParam } = useApi();

  const scrollToTop = () => {
    scroll.scrollToTop();
  }

  let fromDate = "";
  let toDate = "";
  if (interval && interval != "") {
    switch (interval) {
      case "monthly":
        fromDate = fromMonthly(filter.state.filteredDateFrom);
        toDate = toMonthly(filter.state.filteredDateTo);
        break;
      case "daily":
        fromDate = fromDaily(date);
        toDate = toDaily(date);
        break;
      case "hourly":
        fromDate = fromHourly(date);
        toDate = toHourly(date);
        break;
      case "minutes":
        fromDate = fromDetail(date);
        toDate = toDetail(date, 5);
        break;
      default:
        break;
    }
  }

  const handleChangeDateSingle = (date) => {
    props.history.push(`/dashboard/details?activeGroup=${activeGroup}&date=${date}&interval=${interval}`);
  };

  const handleDateChange = (dateTime) => {
    props.history.push(`/dashboard/details?activeGroup=${activeGroup}&date=${dateTime}&interval=${interval}`);
  };

  // ツイート詳細情報を取得
  const rquestTweets = () => {
    // 戻るボタンやURL直貼りで遷移してきたとき、queryParams と auth.state の activeGroup が食い違っていても、
    // 初回レンダでは state の activeGroup （デフォルトグループ）でリクエストして返されたデータで画面表示されてしまう。
    // Layout.js で queryParams と auth.state の activeGroup の同期をとったあとで走る再レンダ時のリクエストで
    // 後からデータを取得しても画面に反映されない（set○○(●●)までで再々レンダは走らない）ので、
    // 同期前で食い違いがあるうちはリクエストしない。
    const activeGroup = queryParams.get("activeGroup");
    if (activeGroup && auth.state.activeGroup !== parseInt(activeGroup, 10)) {
      return;
    }

    request({
      method: "GET",
      url: `data/:account_id/tweets/${
        auth.state.activeGroup
      }/statuses?${convertQueryParam({
        range: [fromDate, toDate],
        filter: {
          pn: filter.state.posiNegaTab,
        },
        order: order,
        pagination: {
          page: page,
          limit: 50,
        },
      })}`,
    }).then((data) => {
      setTotalCount(data.meta.total_count);
      setRetweetCount(data.meta.rt_count);
      setTweets(data.data);
      scrollToTop()
    });
  }

  // 初回レンダリングフラグ
  const isFirstRender = React.useRef(false);
  React.useEffect(() => {
    isFirstRender.current = true;
  }, [])

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, auth.state.user.account_id);
  }, [props.location.pathname]);

  React.useEffect(() => {
    // 初回レンダー判定
    if(isFirstRender.current) {
      // 初回レンダーではないように
      isFirstRender.current = false;
    } else {
      rquestTweets();
    }
  }, [page, auth.state.activeGroup]);

  const syncQueryPageNum = (...[pn]) => {
    if ((pn && pn === 1) || (totalCount > 0 && (Math.ceil(totalCount / 50)) < getQueryPageNum(queryParams))) {
      modQueryPageNum(queryParams, 1);
      props.history.push(props.location.pathname + "?" + queryParams.toString());
      setPage(1);
    }
    else {
      setPage(getQueryPageNum(queryParams));
    }
  }

  React.useEffect(() => {
    if (auth.state.activeGroup === 0) {
      return;
    }

    if (page === 1) {
      rquestTweets();
    } else {
      syncQueryPageNum(1);
    }
  }, [auth.state.groups, filter.state, order, fromDate, toDate]);

  const HeadDate = () => {
    if (interval === "monthly") {
      return (
        <DatePickers onChange={{}} />
      );
    }
    if (interval === "daily") {
      return (
        <DateSinglePicker
          date={fromDate}
          onChange={(date) => handleChangeDateSingle(date)}
        />
      );
    }
    if (interval === "hourly" || interval === "minutes") {
      return (
        <DateTimePicker
          dateTime={fromDate}
          handleDateChange={handleDateChange}
          step={interval}
        />
      );
    }
  };

  if (page !== getQueryPageNum(queryParams)) {
    syncQueryPageNum();
  }
  return (
    <Layout
      content={
        <Grid container spacing={3}>
          <Toolbar className={classes.sticky}>
            <Grid item xs={12}>
              <Grid
                container
                direction="row"
                alignItems="flex-end"
                justifyContent="flex-start"
              >
                <HeadDate />
                <div className={classes.divider}></div>
                <PosiTabs />
                <div className={classes.divider}></div>
                <OrderSelect
                  handleChangeOrderSelect={(value) => {
                    setOrder(value);
                  }}
                  value={order}
                  isRetweet={true}
                />
                <div className={classes.divider}></div>
                <FormControl component="fieldset" className={classes.formControl}>
                  <FormGroup>
                    <FormControlLabel
                      control={<Switch size="small" checked={isHideImage} onChange={(event) => setIsHideImage(event.target.checked)} name="isHideImage" />}
                      label="画像を表示しない"
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
              <Grid container spacing={3} className={classes.formControl} justifyContent="center">
                <MyPagination
                count={Math.ceil(totalCount / 50)}
                currentPage={page}
                handlePagination={(page) => setPage(page)}
                />
              </Grid>
            </Grid>
          </Toolbar>
          <Grid item xs={12}>
            {tweets.map((row, index) => (
              <Tweet row={row} key={row.id_str} isHideImage={isHideImage} order={order} retweetCount={retweetCount[index]} />
            ))}
          </Grid>
        </Grid>
      }
    />
  );
}

export default withRouter(Page);
